import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/mensajeInterno/importer/mensajeInternoImporterActions';

export default importerReducers(actions);
